import { Converter } from '../types/converter';

export const soundConverter: Converter = {
  id: 'sound',
  name: 'Sound Converter',
  icon: 'Volume2',
  categories: ['other'],
  units: [
    // Base units
    { name: 'Bel', symbol: 'B', factor: 10 },
    { name: 'Decibel', symbol: 'dB', factor: 1 },
    { name: 'Neper', symbol: 'Np', factor: 8.685889638 },
    
    // Sound pressure level
    { name: 'Phon', symbol: 'phon', factor: 1 },
    { name: 'Sone', symbol: 'sone', factor: 10 },

    // Sound power
    { name: 'Acoustic watt', symbol: 'W', factor: 1 },
    { name: 'Picowatt', symbol: 'pW', factor: 1e-12 },
    { name: 'Nanowatt', symbol: 'nW', factor: 1e-9 },
    { name: 'Microwatt', symbol: 'µW', factor: 1e-6 },
    { name: 'Milliwatt', symbol: 'mW', factor: 1e-3 },

    // Sound intensity
    { name: 'Watt/square meter', symbol: 'W/m²', factor: 1 },
    { name: 'Picowatt/square meter', symbol: 'pW/m²', factor: 1e-12 },
    { name: 'Nanowatt/square meter', symbol: 'nW/m²', factor: 1e-9 },
    { name: 'Microwatt/square meter', symbol: 'µW/m²', factor: 1e-6 },
    { name: 'Milliwatt/square meter', symbol: 'mW/m²', factor: 1e-3 }
  ]
};
